import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ReasoningIcon } from 'assets/icons/ai.svg';

import AiChatMarkdown from './AiChatMarkdown';
import ChatStepIcon from './ChatStepIcon';

import type { ReactElement } from 'react';
import type IAiChatReasoning from '../interfaces/IAiChatReasoning';

import styles from '../sass/AiChat.module.scss';

/**
 * The summary the model wrote about its own reasoning, collapsed by default.
 *
 * Held open while the run is still being written, so the text can be read as it arrives, and
 * collapsed again once it closes unless the reader opened it themselves.
 */
function AiChatReasoning({ text, isStreaming }: IAiChatReasoning): ReactElement {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const isOpen = isExpanded || !!isStreaming;

  const handleToggle = () => setIsExpanded((current) => !current);

  return (
    <div className={styles.stepRow}>
      <ChatStepIcon icon={<ReasoningIcon />} />

      <div className={styles.reasoning}>
        {isStreaming ? (
          <p className={styles.reasoningLabel}>{t('aiChat.reasoningLive')}</p>
        ) : (
          <button type="button" className={styles.reasoningToggle} onClick={handleToggle}>
            {isExpanded ? t('aiChat.hideReasoning') : t('aiChat.showReasoning')}
          </button>
        )}

        {isOpen ? (
          <AiChatMarkdown text={text} isStreaming={isStreaming} className={styles.reasoningText} />
        ) : null}
      </div>
    </div>
  );
}

export default AiChatReasoning;
